var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeReportEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#E9ECEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 22.5834L26.25 28.9167V38.4167C26.25 47.2042 32.33 55.4217 40.5 57.4167C48.67 55.4217 54.75 47.2042 54.75 38.4167V28.9167L40.5 22.5834ZM45.3767 46.3334L40.5 43.4042L35.6392 46.3334L36.9217 40.7917L32.6308 37.0867L38.2992 36.5959L40.5 31.3709L42.7008 36.58L48.3692 37.0709L44.0783 40.7917L45.3767 46.3334Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeReportEmpty);
export default __webpack_public_path__ + "static/media/BadgeReportEmpty.b4ae9468cf838ce71d7674dabe5fb80a.svg";
export { ForwardRef as ReactComponent };